import React from 'react';
import PropTypes from 'prop-types';
import ASQSimpleSurveysHeader from './ASQSimpleSurveysHeader';
import ASQSimpleSurveysRow from './ASQSimpleSurveysRow';
import { isEmpty } from 'lodash';
import { tableNoResults, tableSpinner } from '../helpers/TableHelpers';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { ANIMATIONS } from 'utils/Animations';

const SurveyTable = ({ pqType, surveys, auth, playerId, location, onASQLink, isLoading }) => (
  <div className='o-rtable o-rtable--bordered o-rtable--asq-simple'>
    <ASQSimpleSurveysHeader meta={{}} onSortChange={() => {}} />
    {isEmpty(surveys) ? tableNoResults() :
      isLoading ? tableSpinner() :
        <TransitionGroup exit={false}>
          {surveys.map((s, i) => (
            <CSSTransition key={s.id} timeout={{ enter: ANIMATIONS.in, exit: 0 }} classNames='a-fade'>
              <ASQSimpleSurveysRow
                playerId={playerId}
                auth={auth}
                survey={s}
                pqType={pqType}
                playerIdx={i}
                onASQLink={onASQLink}
                location={location}
              />
            </CSSTransition>
          ))}
        </TransitionGroup>
    }
  </div>
);

SurveyTable.propTypes = {
  pqType: PropTypes.oneOf(['parent', 'teacher']).isRequired,
  surveys: PropTypes.arrayOf(PropTypes.object).isRequired,
  auth: PropTypes.object.isRequired,
  playerId: PropTypes.number.isRequired,
  location: PropTypes.object.isRequired,
  onASQLink: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default class ASQSimpleSurveysTable extends React.Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired,
    isFetching: PropTypes.bool.isRequired,
    location: PropTypes.object.isRequired,
    meta: PropTypes.object.isRequired,
    onASQLink: PropTypes.func.isRequired,
    onSortChange: PropTypes.func.isRequired,
    playerId: PropTypes.number.isRequired,
    surveys: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  }

  state = { activeTab: 'parent' }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextState.activeTab !== this.state.activeTab) return true;
    return !nextProps.isFetching;
  }

  render() {
    const { auth, isLoading, location, playerId, surveys, onASQLink } = this.props;
    const { activeTab } = this.state;

    if (!surveys) return tableNoResults();

    const parentSurveys = surveys.parentSurveys || surveys.parent_surveys || [];
    const teacherSurveys = surveys.teacherSurveys || surveys.teacher_surveys || [];

    if (isEmpty(parentSurveys) && isEmpty(teacherSurveys)) return tableNoResults();

    return (
      <div className='u-margin-bottom--gutter2x'>
        <div className='o-asq-tabs'>
          <button
            className={`o-asq-tabs__tab${activeTab === 'parent' ? ' o-asq-tabs__tab--active' : ''}`}
            onClick={() => this.setState({ activeTab: 'parent' })}
          >
            Parent Surveys
          </button>
          <button
            className={`o-asq-tabs__tab${activeTab === 'teacher' ? ' o-asq-tabs__tab--active' : ''}`}
            onClick={() => this.setState({ activeTab: 'teacher' })}
          >
            Teacher Surveys
          </button>
        </div>
        {activeTab === 'parent' && (
          <SurveyTable
            pqType='parent'
            surveys={parentSurveys}
            auth={auth}
            playerId={playerId}
            location={location}
            onASQLink={onASQLink}
            isLoading={isLoading}
          />
        )}
        {activeTab === 'teacher' && (
          <SurveyTable
            pqType='teacher'
            surveys={teacherSurveys}
            auth={auth}
            playerId={playerId}
            location={location}
            onASQLink={onASQLink}
            isLoading={isLoading}
          />
        )}
      </div>
    );
  }
}
